import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar, Hero } from "@/components/site/NavHero";
import { Services, Pricing, Hours, Location, Footer, Marquee, BarLife, Tornei, Sparapalline, WhatsApp } from "@/components/site/Sections";
import { TorneiPrivati } from "@/components/site/TorneiPrivati";

const MEDIA = {
  hero_background:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/s7ni0k7r_IMG_6533.jpeg",
  courts_overview:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/o979ced1_IMG_6534.jpeg",
  courts_lateral:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/vtxochjo_IMG_6535.jpeg",
  pickleball:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/3nbw9t4l_IMG_6553.jpeg",
  match_action:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/ia13ybdn_IMG_6534.jpeg",
  locker_room:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/txh7scwo_IMG_6535.jpeg",
  showers:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/ll63cway_IMG_6536.jpeg",
  bar_counter:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/nxrs7394_IMG_6545.jpeg",
  bar_aperitivo:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/tgujvqah_IMG_6538.jpeg",
  bar_aperitivo_2:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/d3fkfyhp_IMG_6533.jpeg",
  bar_beers:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/8r4ckr7f_IMG_6544.jpeg",
  bar_drinks:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/pu1971m7_IMG_6548.jpeg",
  match_real:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/j4j4yi3f_IMG_6540.jpeg",
  youth_match:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/gfao3cpo_IMG_6543.jpeg",
  shop_sane:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/46idg3d1_IMG_6542.jpeg",
  sane_wall:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/spu7d7qe_IMG_6547.jpeg",
  bar_aperitivo_3:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/nm8tqf5r_IMG_6548.jpeg",
  tornei:
    "https://customer-assets.emergentagent.com/job_elvo-tennis-padel/artifacts/abnt6x21_IMG_6537.jpeg",
};

const Home = () => (
  <div className="App bg-[#0A0A0A] min-h-screen">
    <Navbar />
    <Hero image={MEDIA.hero_background} />
    <Marquee />
    <Services media={MEDIA} />
    <Sparapalline media={MEDIA} />
    <BarLife media={MEDIA} />
    <Tornei media={MEDIA} />
    <TorneiPrivati />
    <WhatsApp />
    <Pricing />
    <Hours />
    <Location />
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
